import React from 'react';
import './CountWidget.css';

interface CountWidgetProps {
  appid: string;
  name: string;
  topic: string;
  index: number;
  count: number;
}

const CountWidget: React.FC<CountWidgetProps> = ({ appid, name, topic, index, count }) => {
  return (
    <div className="diagnostics-count-widget">
      <div className="d-flex gap-2 align-items-baseline diagnostics-count-widget-heading">
        <div className="diagnostics-count-widget-number">{index + 1}</div>
        <h6 className="diagnostics-count-widget-title mb-1">{name}</h6>
      </div>
      
      {appid && (
        <p className="diagnostics-count-widget-appid">{appid}</p>
      )}
      
      {topic && (
        <p className="diagnostics-count-widget-topic">{topic}</p>
      )}
      
      <div className="diagnostics-count-widget-count-row">
        <span className="diagnostics-count-widget-status danger">❌</span>
        <span className="diagnostics-count-widget-count">{count}</span>
      </div>
    </div>
  );
};

export default CountWidget;